// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FhdaW8KFDe {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.FhdaW8KFDe h4 {
  line-height: 3em;
}
.FhdaW8KFDe .YFd4ZBlsMu {
  float: left;
  width: 100%;
}
.FhdaW8KFDe .CWmrofcHNx {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.FhdaW8KFDe .CWmrofcHNx:hover {
  cursor: pointer;
}
.FhdaW8KFDe .CWmrofcHNx:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.tZ2bi4n2BU .zLkWf6SSoA:focus {
  outline: none;
}
.tZ2bi4n2BU .zLkWf6SSoA.z7jT0rewoq.dGU6bwM_HU {
  background: #375A88;
}
.tZ2bi4n2BU .zLkWf6SSoA.z7jT0rewoq.dGU6bwM_HU span {
  color: #fff;
}
.tZ2bi4n2BU .dGU6bwM_HU {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.tZ2bi4n2BU .dGU6bwM_HU:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.tZ2bi4n2BU input {
  height: 38px;
  min-width: 220px;
}
.CWmrofcHNx.nHT8EDY3aq {
  background: #410102;
}
.CWmrofcHNx.C85FPsQawh {
  background: #911318;
}
.CWmrofcHNx.ZYt2TJNSV2 {
  background: #D8293B;
}
.CWmrofcHNx.hlWB4N9JRE {
  background: #F2373C;
}
.CWmrofcHNx.tAfctCd9bo {
  background: #FC4448;
}
.CWmrofcHNx.MkqyQSkQDv {
  background: #ED535E;
}
.CWmrofcHNx.cmcW8HJAw0 {
  background: #E34926;
}
.CWmrofcHNx.eMWuhxS5AG {
  background: #FC562B;
}
.CWmrofcHNx.p0EiY2v1q0 {
  background: #FC6722;
}
.CWmrofcHNx.MojPa94dAg {
  background: #FD7F24;
}
.CWmrofcHNx.bgctoe8fRS {
  background: #FD8D26;
}
.CWmrofcHNx.W3u9uZzcz_ {
  background: #EC9C3E;
}
.CWmrofcHNx.t1bbgGvgoU {
  background: #0e673a;
}
.CWmrofcHNx.MDfkLMOXOz {
  background: #208740;
}
.CWmrofcHNx.TRK9X83Z72 {
  background: #239718;
}
.CWmrofcHNx.tTN14r5fJn {
  background: #55A84D;
}
.CWmrofcHNx.FO94o6_yLN {
  background: #4BBE5A;
}
.CWmrofcHNx.HkEIMufA9h {
  background: #0CCA6A;
}
.CWmrofcHNx.MAoUoJly9F {
  background: #0A3C64;
}
.CWmrofcHNx.O1pVmYQ8GR {
  background: #0d487a;
}
.CWmrofcHNx.g_J58_Zcqa {
  background: #10538d;
}
.CWmrofcHNx.cuVaz_CY0C {
  background: #115A99;
}
.CWmrofcHNx.UmDxYNJypI {
  background: #3387E2;
}
.CWmrofcHNx.An4zm68FD5 {
  background: #1BA9CF;
}
.CWmrofcHNx.DIcY6u7NSz {
  background: #d27c02;
}
.CWmrofcHNx.o3uvafEH3x {
  background: #fb9402;
}
.CWmrofcHNx.GMhNrafnZe {
  background: #FD9B30;
}
.CWmrofcHNx.n91TgMqQLA {
  background: #FDBE2D;
}
.CWmrofcHNx.jOBnuOv8CT {
  background: #FED831;
}
.CWmrofcHNx.vqKUPdqxPc {
  background: #FFFD38;
}
.CWmrofcHNx.dsGK0vQDqu {
  background: #2D215C;
}
.CWmrofcHNx.voRL1TtBOu {
  background: #483C83;
}
.CWmrofcHNx.YRNYn01tjB {
  background: #58518d;
}
.CWmrofcHNx.uyVnWYEO0o {
  background: #7068A9;
}
.CWmrofcHNx.kmG1xw8Pwd {
  background: #7f78b2;
}
.CWmrofcHNx.z2rK6FygWC {
  background: #8f88bc;
}
.CWmrofcHNx.yNID6qpK8y {
  background: #000;
}
.CWmrofcHNx.Ty3525h0Ls {
  background: #282626;
}
.CWmrofcHNx.NCPHywHnE_ {
  background: #242222;
}
.CWmrofcHNx.J8S2o7m3va {
  background: #353838;
}
.CWmrofcHNx.HZjmWEQxnN {
  background: #666;
}
.CWmrofcHNx.xs9sYtRYkd {
  background: #999;
}
.LYS0XUpxc3 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.LYS0XUpxc3 .wY4ftgbZiI {
  display: none;
}
.ZAuJ8tcNj5 {
  flex: 3 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ZAuJ8tcNj5 span {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
}
.Fi0ojnIms9 {
  flex: 2 1 0;
}
.xoLd71L0gx {
  flex: 1;
  min-width: 0;
  font-size: 11px;
  margin: 0;
  background: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: none;
}
.oFaVKKyDYp:hover,
.oFaVKKyDYp:focus {
  display: flex;
  align-items: center;
  background-color: #F5E6BF;
  border: 1px solid #F4B941;
  min-height: 24px;
  padding: 0 8px;
  overflow: hidden;
  cursor: pointer;
}
.jWaOVlElnJ.jWaOVlElnJ {
  flex: 1;
  min-width: 0;
}
[contentEditable] {
  outline: 0 solid transparent;
}
.PJWwaTw3fp {
  flex: 1 1 0;
  min-width: 80px;
  margin-bottom: 16px;
  cursor: pointer;
}
.QOrBG3TXW6 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin: 8px;
  font-size: 11px;
  width: 120px;
}
.QOrBG3TXW6 .VUyfLChVcU {
  color: #53A92C;
  margin-right: 4px;
  font-size: 11px;
  flex-shrink: 0;
}
.QOrBG3TXW6 .Q_0u_gjoBx {
  font-weight: normal;
  text-transform: capitalize;
  white-space: nowrap;
}
.QOrBG3TXW6 .Tu3M1azTGq {
  color: #EAAC6D;
}
.fj0fWPX64P {
  flex: 1 1 0;
  min-width: 80px;
  max-width: 80px;
  display: flex;
  align-items: center;
  margin: 8px;
}
.fj0fWPX64P .O35OHbmfFn {
  font-size: 10px;
  flex-shrink: 0;
}
.fj0fWPX64P .OY6PSOleoy {
  font-weight: normal;
  font-size: 11px;
  padding-left: 4px;
  text-transform: capitalize;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.GMdEaXHqzy {
  flex: 0 0 auto;
  margin: 0 8px;
  cursor: pointer;
}
.GMdEaXHqzy .JhvOevYe0h {
  font-size: 17px;
}
.gsO4FDitSI {
  color: #959499;
  cursor: default;
}
.Cv49AUPixC {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin: 0 8px;
}
.Cv49AUPixC .cVpXPoSMkr {
  font-size: 10px;
  flex-shrink: 0;
}
.Cv49AUPixC .fRdTOwZMaT {
  font-weight: normal;
  font-size: 11px;
  padding-left: 4px;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
}
.b7qPlZ1Yjf {
  flex: 0 0 auto;
  font-weight: normal;
  font-size: 11px;
}
.b6N2dCJHMs {
  font-size: 11px;
  margin: 8px;
}
.FcfyVYgxKu {
  flex: 0 0 auto;
  font-size: 11px;
  margin: 8px;
  cursor: pointer;
}
.Q4Nij_qvui.Q4Nij_qvui {
  padding: 0 16px;
  cursor: default !important;
}
.Q4Nij_qvui.Q4Nij_qvui .rSE8khYfVx {
  padding: 8px;
  font-weight: 400;
}
.Q4Nij_qvui.Q4Nij_qvui .rSE8khYfVx .vmx8TsWv73 {
  text-transform: initial;
}
.Q4Nij_qvui.Q4Nij_qvui .aZ8HVG5xsm {
  display: none;
}
.Q4Nij_qvui.Q4Nij_qvui .DAOlVbgSiN {
  margin-right: 8px;
  cursor: pointer;
}
.Q4Nij_qvui.Q4Nij_qvui > * {
  min-width: 0;
}
.Q4Nij_qvui.Q4Nij_qvui .ZAuJ8tcNj5,
.Q4Nij_qvui.Q4Nij_qvui .PJWwaTw3fp,
.Q4Nij_qvui.Q4Nij_qvui .QOrBG3TXW6,
.Q4Nij_qvui.Q4Nij_qvui .fj0fWPX64P,
.Q4Nij_qvui.Q4Nij_qvui .Cv49AUPixC {
  display: flex;
  align-items: center;
}
.cFeXEdWWPK {
  position: relative;
}
.cFeXEdWWPK .removeIcon {
  flex: 0 0 auto;
  font-size: 11px;
  padding-left: 4px;
  position: absolute;
  right: 8px;
  color: #D93A40;
  visibility: hidden;
  cursor: pointer;
}
.cFeXEdWWPK .MuiAccordionSummary-content:hover .removeIcon {
  visibility: visible;
}
.cFeXEdWWPK .MuiAccordionSummary-content:hover .removeIcon--hide {
  visibility: hidden;
}
.E7_qXSV9d0 {
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `FhdaW8KFDe`,
	"color-row": `YFd4ZBlsMu`,
	"color-tile": `CWmrofcHNx`,
	"picker-component": `tZ2bi4n2BU`,
	"picker-element": `zLkWf6SSoA`,
	"active": `z7jT0rewoq`,
	"btn": `dGU6bwM_HU`,
	"red-1": `nHT8EDY3aq`,
	"red-2": `C85FPsQawh`,
	"red-3": `ZYt2TJNSV2`,
	"red-4": `hlWB4N9JRE`,
	"red-5": `tAfctCd9bo`,
	"red-6": `MkqyQSkQDv`,
	"orange-1": `cmcW8HJAw0`,
	"orange-2": `eMWuhxS5AG`,
	"orange-3": `p0EiY2v1q0`,
	"orange-4": `MojPa94dAg`,
	"orange-5": `bgctoe8fRS`,
	"orange-6": `W3u9uZzcz_`,
	"green-1": `t1bbgGvgoU`,
	"green-2": `MDfkLMOXOz`,
	"green-3": `TRK9X83Z72`,
	"green-4": `tTN14r5fJn`,
	"green-5": `FO94o6_yLN`,
	"green-6": `HkEIMufA9h`,
	"blue-1": `MAoUoJly9F`,
	"blue-2": `O1pVmYQ8GR`,
	"blue-3": `g_J58_Zcqa`,
	"blue-4": `cuVaz_CY0C`,
	"blue-5": `UmDxYNJypI`,
	"blue-6": `An4zm68FD5`,
	"yellow-1": `DIcY6u7NSz`,
	"yellow-2": `o3uvafEH3x`,
	"yellow-3": `GMhNrafnZe`,
	"yellow-4": `n91TgMqQLA`,
	"yellow-5": `jOBnuOv8CT`,
	"yellow-6": `vqKUPdqxPc`,
	"purple-1": `dsGK0vQDqu`,
	"purple-2": `voRL1TtBOu`,
	"purple-3": `YRNYn01tjB`,
	"purple-4": `uyVnWYEO0o`,
	"purple-5": `kmG1xw8Pwd`,
	"purple-6": `z2rK6FygWC`,
	"black-1": `yNID6qpK8y`,
	"black-2": `Ty3525h0Ls`,
	"black-3": `NCPHywHnE_`,
	"black-4": `J8S2o7m3va`,
	"black-5": `HZjmWEQxnN`,
	"black-6": `xs9sYtRYkd`,
	"picker-theme": `LYS0XUpxc3`,
	"arrow-regular": `wY4ftgbZiI`,
	"stageInfo": `ZAuJ8tcNj5`,
	"stageInfoEdit": `Fi0ojnIms9`,
	"reviewStage": `xoLd71L0gx`,
	"reviewStageEditable": `oFaVKKyDYp`,
	"reviewStageDetail": `jWaOVlElnJ`,
	"processStatus": `PJWwaTw3fp`,
	"statusSummary": `QOrBG3TXW6`,
	"statusIcon": `VUyfLChVcU`,
	"statusName": `Q_0u_gjoBx`,
	"clockIcon": `Tu3M1azTGq`,
	"triggerType": `fj0fWPX64P`,
	"triggerTypeIcon": `O35OHbmfFn`,
	"triggerTypeName": `OY6PSOleoy`,
	"stagePlayButton": `GMdEaXHqzy`,
	"stagePlayButtonIcon": `JhvOevYe0h`,
	"stage-play-button--disable": `gsO4FDitSI`,
	"stageDecisionName": `Cv49AUPixC`,
	"stageDecisionNameIcon": `cVpXPoSMkr`,
	"stageDecisionNameLabel": `fRdTOwZMaT`,
	"dueDate": `b7qPlZ1Yjf`,
	"dueDateIcon": `b6N2dCJHMs`,
	"gearIcon": `FcfyVYgxKu`,
	"summary__root": `Q4Nij_qvui`,
	"tooltip-root": `rSE8khYfVx`,
	"stage-decision-rule__tooltip": `vmx8TsWv73`,
	"summary__icon": `aZ8HVG5xsm`,
	"summary__expand-icon": `DAOlVbgSiN`,
	"accordion": `cFeXEdWWPK`,
	"reviewFieldDetail": `E7_qXSV9d0`
};
export default ___CSS_LOADER_EXPORT___;
